import template from "./settings-team.html";

const SettingsTeamComponent = {
  template: template,

  controller: class SettingsTeamController {
    /* @ngInject */
    constructor(
      $rootScope,
      $filter,
      User,
      OrganizationService,
      Notification,
      SweetAlertService,
      TrackingStateService,
      errorMessages
    ) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.User = User;
      this.OrganizationService = OrganizationService;
      this.NotificationService = Notification;
      this.SweetAlertService = SweetAlertService;
      this.TrackingStateService = TrackingStateService;
      this.errorMessages = errorMessages;
    }

    async $onInit() {
      this.team = [];
      this.loadingUsers = false;
      this.organization = this.$rootScope.organization;
      this.activeUserIsAdmin = this.organization.organizationUsers.some(
        (employee) =>
          employee.user.id === this.$rootScope.user.id &&
          employee.role === "admin"
      );

      this.$rootScope.$applyAsync();

      await this._refreshTeam();
    }

    async toggleAdmin(user) {
      await this.OrganizationService.toggleAdmin(user.id);
    }

    async _refreshTeam() {
      this.loadingUsers = true;
      this.team = await this.User.getTeam();
      this.loadingUsers = false;
      this.$rootScope.$applyAsync();
    }
  },
};

export default SettingsTeamComponent;
